import { apiClient } from './client';

export interface CSVExportRequest {
  template: string;
  format: 'csv' | 'tsv';
  includeHeader: boolean;
  filename: string;
}

export interface CSVExportStatus {
  can_export: boolean;
  current_count: number;
  max_count: number | null;
  remaining: number | null;
}

export interface CSVExportResponse {
  data: string;
  filename: string;
  format: string;
}

class CSVExportApi {
  async getExportStatus(): Promise<CSVExportStatus> {
    const response = await apiClient.get('/api/csv-export/status');
    return (response as any).data;
  }

  async exportCSV(exportData: CSVExportRequest): Promise<CSVExportResponse> {
    const response = await apiClient.post('/api/csv-export', exportData);
    return (response as any).data;
  }
}

export const csvExportApi = new CSVExportApi();